import { render, staticRenderFns } from "./mediaForm.vue?vue&type=template&id=d38edb00"
import script from "./mediaForm.vue?vue&type=script&lang=js"
export * from "./mediaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports